import { render, staticRenderFns } from "./TechnicalResponsibleValidationsPending.vue?vue&type=template&id=1dc119a0&scoped=true&"
import script from "./TechnicalResponsibleValidationsPending.vue?vue&type=script&lang=js&"
export * from "./TechnicalResponsibleValidationsPending.vue?vue&type=script&lang=js&"
import style0 from "./TechnicalResponsibleValidationsPending.vue?vue&type=style&index=0&id=1dc119a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc119a0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
